import { SxProps, Theme } from "@mui/material";
import { BaseFormMode } from "../hooks/useFormHooks";

export interface FormModeStyle {
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
  readOnly?: boolean;
  disabled?: boolean;
}

export const BASE_FORMMODE_STYLES: Record<BaseFormMode, FormModeStyle> = {
  create: {
    backgroundColor: "#ffffff",
    textColor: "#000000",
    borderColor: "#1976d2",
    readOnly: false,
    disabled: false,
  },
  edit: {
    backgroundColor: "#fffde7",
    textColor: "#000000",
    borderColor: "#f57c00",
    readOnly: false,
    disabled: false,
  },
  view: {
    backgroundColor: "#f5f5f5",
    textColor: "#000000",
    borderColor: "#bdbdbd",
    readOnly: false,
    disabled: true,
  },
};

export type FormModeStyleEntry = FormModeStyle | BaseFormMode;

export type CustomFormModeStylesMap<TMode extends string> = {
  [K in Exclude<TMode, BaseFormMode>]: FormModeStyleEntry;
};

export function resolveFormModeStyle<TMode extends string>(
  mode: TMode,
  customStyles?: CustomFormModeStylesMap<TMode>,
): FormModeStyle {
  if (mode in BASE_FORMMODE_STYLES) {
    return BASE_FORMMODE_STYLES[mode as BaseFormMode];
  }

  if (!customStyles) {
    throw new Error(`No modeStyles provided for custom mode: "${mode}"`);
  }

  const entry = customStyles[mode as Exclude<TMode, BaseFormMode>];
  if (typeof entry === "string") {
    return BASE_FORMMODE_STYLES[entry as BaseFormMode];
  }

  return entry;
}

export function formModeStyleToSx(style: FormModeStyle): SxProps<Theme> {
  return {
    backgroundColor: style.backgroundColor,
    "& .MuiInputBase-input": {
      color: style.textColor,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: style.borderColor,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: style.borderColor,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: style.borderColor,
    },
  };
}
